// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-panel-callout-content {
  margin: 16px;
  border-radius: 6px;
  overflow: hidden;
}
@media (forced-colors: active) {
  .bolt-panel-callout-content {
    border: solid 1px;
  }
}
.bolt-panel-callout-content.bolt-callout-shadow {
  box-shadow: 0px 25.6px 57.6px rgba(0, 0, 0, .22), 0px 4.8px 14.4px rgba(0, 0, 0, .18);
  box-shadow: 0px 25.6px 57.6px var(--panel-shadow-color,rgba(0, 0, 0, .22)), 0px 4.8px 14.4px var(--panel-shadow-secondary-color,rgba(0, 0, 0, .18));
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-panel-callout-content.bolt-callout-shadow {
  border: 2px solid rgba(0, 120, 212, 1);
  border: 2px solid var(--focus-border-color,rgba(0, 120, 212, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-panel-callout-content.bolt-callout-shadow {
  border: 2px solid rgba(0, 120, 212, 1);
  border: 2px solid var(--focus-border-color,rgba(0, 120, 212, 1));
}
.bolt-panel-callout-content.bolt-panel-fullscreen {
  margin: 0px;
  max-height: none;
  max-width: none;
  height: auto;
  width: auto;
  border-radius: 0px;
}

.bolt-panel-resizable {
  position: relative;
}

.bolt-panel-resize-handle {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  cursor: col-resize;
  z-index: 1;
  outline-width: 0;
  user-select: none;
  background-color: transparent;
}
.bolt-panel-resize-handle:hover, .bolt-panel-resize-handle:active {
  background-color: rgba( 234, 234, 234 ,  1 );
  background-color: rgba( var(--palette-neutral-8,234, 234, 234) ,  1 );
}
.bolt-focus-visible .bolt-panel-resize-handle:focus {
  background-color: rgba( 234, 234, 234 ,  1 );
  background-color: rgba( var(--palette-neutral-8,234, 234, 234) ,  1 );
  outline: 1px solid rgba(0, 120, 212, 1);
  outline: 1px solid var(--focus-border-color,rgba(0, 120, 212, 1));
  outline-offset: -1px;
}

.bolt-panel-callout-content.bolt-panel-resizing {
  user-select: none;
  cursor: col-resize;
}

body[data-resize-active=true] {
  cursor: col-resize !important;
  user-select: none;
}

.bolt-panel-description {
  margin-right: 36px;
  color: rgba(0, 0, 0, .55);
  color: var(--text-secondary-color,rgba(0, 0, 0, .55));
}

.bolt-panel-footer {
  min-height: 64px;
  overflow: hidden;
  padding-bottom: 16px;
  padding-top: 16px;
}

.bolt-panel-footer-buttons {
  justify-content: flex-end;
  font-size: 0.875rem;
}

.bolt-panel-content {
  position: relative;
  min-height: 64px;
}

.bolt-panel-separator {
  height: 1px;
  background-color: rgba( 244, 244, 244 ,  1 );
  background-color: rgba( var(--palette-neutral-4,244, 244, 244) ,  1 );
}

.bolt-panel-overlay {
  background-color: rgba(255, 255, 255, 1);
  background-color: var(--callout-background-color,rgba(255, 255, 255, 1));
  opacity: 0.7;
}

@media screen and (max-width: 599px) {
  .bolt-panel-header .bolt-header-content-area {
    flex-wrap: nowrap;
  }
}
@media screen and (max-width: 599px) {
  .bolt-panel-header .bolt-header-title {
    white-space: normal;
    word-break: break-word;
  }
}

/*# sourceMappingURL=Panel.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Panel/Panel.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/Panel/Panel.css","webpack://./../azure-devops-ui/src/_coreStyles.scss"],"names":[],"mappings":"AAGA;EACI,YCyTS;EDxTT,kBAAA;EACA,gBAAA;AEFJ;AC2CI;EH5CJ;IAMQ,iBAAA;EEDN;AACF;AFGI;EACI,qFAAA;EEDN,mJAAmJ;AD0X7I;ACxXR;EACE,sCAAsC;ED0XhC,gEAAA;ACxXR;AACA;EFEI,sCAAA;EACI,gEAAA;AEAR;AACA;EFEQ,WAAA;EACA,gBAAA;EACA,eAAA;EEAN,YAAY;EACZ,WAAW;EFGb,kBAAA;AEDA;;AAEA;EFGA,kBAAA;AEDA;;AAEA;EFGI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EEDF,gBAAgB;EFGd,iBAAA;EAEI,6BCgCI;AClCZ;AFKI;EACI,4CC4BI;ED3BJ,qEAAA;AEHR;AACA;EACE,4CAA4C;EFM9C,qEAAA;EACI,uCAAA;EACA,iEAAA;EEJF,oBAAoB;AACtB;;AAEA;EFMI,iBAAA;EEJF,kBAAkB;AACpB;;AAEA;EFMI,6BC2Fa;EC/Ff,iBAAiB;AACnB;;AAEA;EFMI,kBAAA;EACA,yBCiPS;EDhPT,qDCgPS;ACpPb;;AFOA;EACI,gBAAA;EAGA,gBCwLQ;EC9LV,oBAAoB;EACpB,iBAAiB;AFQnB;;AELA;EACE,yBAAyB;EACzB,mBAAmB;AFQrB;;AELA;EACE,kBAAkB;EAClB,gBAAgB;AFQlB;;AELA;EACE,WAAW;EACX,4CAA4C;EDkQ1C,qEAAA;AChQJ;;AAEA;EACE,wCAAwC;ED6PtC,wEAAA;EDnPA,YAAA;AEPJ;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,mBAAmB;IACnB,sBAAsB;EACxB;AACF;;AAEA,oCAAoC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
